export default __webpack_public_path__ + "static/media/totalbvstotalifa_graph.492057cf.svg";